import ContactPriorityIcon from './ContactPriorityIcon';
export default ContactPriorityIcon;
